import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDoneResponses } from 'pages/PageApplicationList/api';
import { getMyApplicationAvailableColumns } from './api';

export const path = '/my-application/list';

const PageMyApplications: React.FC = (props) => {
  const MyApplications = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getMyApplicationAvailableColumns,
      doneResponses: getDoneResponses,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <MyApplications {...props} />;
};

export default PageMyApplications;
